const MarketObservationRequiredInternalFields : any =
{
    // ordineOperazione: {
    //     descrStrumFinanziario: ["codiceIdentificativo"],
    // }
}

export default MarketObservationRequiredInternalFields
